const BASE = {
  TRANSACTIONS: "/transactions",
};

export const paths = {
  // Transactions
  transactions: BASE.TRANSACTIONS,
};
